import { FC } from 'react'
import { staticStrings } from '../../data/static/strings'
import { useStores } from '../../data/store'
import { TransactionsType } from '../../screens/TransactionNew/types'
import FieldSetting from './FieldSetting'

interface FieldSettingsProps {
  hide?: boolean
  setFieldSettingVisible: (data: boolean) => void
  fieldSettingVisible: boolean
  applyFilters: () => void
  fetchTxnColumns: () => void
  path?: string
}

const FieldSettings: FC<FieldSettingsProps> = ({
  hide = false,
  setFieldSettingVisible,
  fieldSettingVisible,
  applyFilters,
  fetchTxnColumns,
  path,
}: FieldSettingsProps) => {
  const {
    getALLFields,
    applyFieldsSetting,
    getSubscriptionFields,
    applySubscriptionFields,
    selectAllFields,
    allFieldsSelected,
    updateAllFieldsSelected,
    selectAllSubscriptionFields,
  } = useStores((store) => ({
    getALLFields: store.transactions.getALLFields,
    applyFieldsSetting: store.transactions.applyFieldSettings,
    getSubscriptionFields: store.subscriptions.getSubscriptionFields,
    applySubscriptionFields: store.subscriptions.applySubFieldSettings,
    selectAllFields: store.transactions.selectAllFields,
    allFieldsSelected: store.transactions.filter.allFieldsSelected,
    selectAllSubscriptionFields: store.subscriptions.selectAllSubscriptionFields,
    updateAllFieldsSelected: store.transactions.filter.updateAllFieldsSelected,
  }))

  let fields
  if (path === TransactionsType.subscriptions) {
    fields = getSubscriptionFields()
  } else {
    fields = getALLFields()
  }

  if (hide) {
    return null
  }

  const toggleFieldSettings = (): void => {
    setFieldSettingVisible(!fieldSettingVisible)
  }

  const handleReset = (): void => {
    updateAllFieldsSelected(false)
    fetchTxnColumns()
    setFieldSettingVisible(!fieldSettingVisible)
    if (path === TransactionsType.subscriptions) {
      window.localStorage.setItem('subscription_field_setting', '')
    } else {
      window.localStorage.setItem('transaction_field_setting', '')
    }
  }

  const handleApply = (data: string[]): void => {
    setFieldSettingVisible(!fieldSettingVisible)
    if (path === TransactionsType.subscriptions) {
      window.localStorage.setItem('subscription_field_setting', JSON.stringify(data))
      applySubscriptionFields(data)
    } else {
      window.localStorage.setItem('transaction_field_setting', JSON.stringify(data))
      applyFieldsSetting(data)
    }
    applyFilters()
  }

  return (
    <FieldSetting
      apply={handleApply}
      settingData={fields}
      toggleFieldSettings={toggleFieldSettings}
      staticStrings={staticStrings}
      onReset={handleReset}
      onSelectAll={selectAllFields}
      onSubscrptionFieldsSelectAll={selectAllSubscriptionFields}
      allFieldsSelected={allFieldsSelected}
      updateAllFieldsSelected={updateAllFieldsSelected}
      path={path}
    />
  )
}

export default FieldSettings
